import { render, staticRenderFns } from "./WithoutScript.vue?vue&type=template&id=786c556a&"
import script from "./WithoutScript.vue?vue&type=script&lang=ts&"
export * from "./WithoutScript.vue?vue&type=script&lang=ts&"
import style0 from "./WithoutScript.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports